import { ChangeEvent, FC, Fragment, useState } from 'react';

import { useCartContext } from '../../../hooks/contexts/cart.context';
import { useEventContext } from '../../../hooks/contexts/event.context';
import { useI18nContext } from '../../../hooks/contexts/i18n.context';
import { HolderProps } from '../../../types/cart';
import maskValue from '../../../utils/maskValue';
import * as Styles from './styles.kidsNaming';

type KidsNamingProps = {
    ticketId: number;
};

const KidsNaming: FC<KidsNamingProps> = ({ ticketId }) => {
  const [hasError, setHasError] = useState(false);

  const { listOfDependents, updateDependentList } = useEventContext();
  const { assignTicketToHolder } = useCartContext();
  const { translate } = useI18nContext();

  function assign (event: ChangeEvent<HTMLSelectElement>) {
    const selectedDocument = event.target.value;
    const holder = listOfDependents.find((dependent) => dependent.document === selectedDocument);

    if (!holder) return;

    if (holder.hasTicket) {
      setHasError(true);
      return;
    }

    assignTicketToHolder({
      holder : holder as unknown as HolderProps,
      idSpecificInIdentifyList : ticketId
    });

    updateDependentList({ dependents : listOfDependents.map((dependent) => {
      if (dependent.document === selectedDocument) {
        return { ...dependent, hasTicket : true };
      }
      return dependent;
    }) });
  }

  return (
    <Fragment>
      <Styles.Wrapper $error={hasError}>
        <Styles.Select $error={hasError} onChange={assign}>
          <option value="">{translate(['INFORMATION', 'DEPENDENT'])}</option>
          {listOfDependents.map((dependent) => (
            <option key={dependent.email} value={dependent.document}>
              {`${maskValue(dependent.document)} • ${dependent.name}`}
            </option>
          ))}
        </Styles.Select>
      </Styles.Wrapper>
      {hasError && (
        <Styles.ErrorMessage>
          {translate(['INFORMATION', 'DEPENDENT_ALREADY_ASSOCIATED'])}
        </Styles.ErrorMessage>
      )}
    </Fragment>
  );
};

export default KidsNaming;
